import React from "react";
import { ToolRendererProps } from "./types";

export const ReadFilePartialToolRenderer: React.FC<ToolRendererProps> = ({
  args,
  toolResult,
  renderWithErrorIfFailed,
  getFallbackText,
}) => {
  const filePath = args?.file_path || "";
  const offset = args?.offset;
  const limit = args?.limit;

  if (!filePath) {
    return <>{getFallbackText()}</>;
  }

  const isSkillFile = filePath.includes("/skills/");
  const displayPath = isSkillFile
    ? filePath.split("/").pop() || filePath
    : filePath;

  const startLine = offset !== undefined ? offset + 1 : 1;
  const endLine =
    offset !== undefined && limit !== undefined
      ? offset + limit
      : toolResult?.totalLines;

  const showLineRange = offset !== undefined || limit !== undefined;

  return (
    <>
      {renderWithErrorIfFailed(
        <div className="text-xs text-secondary-n-400 space-y-1">
          <span className="font-mono">{displayPath}</span>
          {showLineRange && (
            <div className="text-secondary-n-500">
              Lines {startLine}–{endLine}
              {toolResult?.totalLines && ` • ${toolResult.totalLines} total`}
            </div>
          )}
        </div>,
      )}
    </>
  );
};
